export default "__VITE_ASSET__rwE2WLPz__"